import React from 'react';
import { motion } from 'framer-motion';
import { spring } from '../../ui/animations';

export function ProgressBar({ value, max = 100, size = 'default', showLabel = false, label = '' }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const colorClass = pct > 65 ? 'fill-green' : pct > 35 ? 'fill-yellow' : 'fill-red';
  const sizeClass = size === 'lg' ? 'lg' : size === 'sm' ? 'sm' : '';

  return (
    <div>
      {showLabel && (
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--text-muted)', marginBottom: 2 }}>
          <span>{label}</span>
          <span style={{ color: 'var(--text)' }}>{Math.round(pct)}%</span>
        </div>
      )}
      <div className={`progress-bar ${sizeClass}`}>
        <motion.div
          className={`fill ${colorClass}`}
          animate={{ width: `${pct}%` }}
          transition={spring}
        />
      </div>
    </div>
  );
}

export function ColorProgressBar({ value, max = 100, colorClass = 'fill-blue', size = 'default' }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const sizeClass = size === 'lg' ? 'lg' : size === 'sm' ? 'sm' : '';
  return (
    <div className={`progress-bar ${sizeClass}`}>
      <motion.div
        className={`fill ${colorClass}`}
        animate={{ width: `${pct}%` }}
        transition={spring}
      />
    </div>
  );
}
